import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { ROUTES } from "constants/routes";

type SearchType = "cargo" | "transport";

export const useLandingSearchNav = (onOpenRegister: () => void) => {
	const navigate = useNavigate();

	const isAuthenticated = useSelector(
		(state: RootState) => state.auth.isAuthenticated,
	);

	const company = useSelector((state: RootState) => state.company.data);

	// ✅ role_id is stored in company
	const roleId = useMemo(() => company?.role_id ?? null, [company]);

	const handleLandingSearchClick = useCallback(
		(type: SearchType) => {
			// 1) not logged -> open register modal
			if (!isAuthenticated) {
				onOpenRegister();
				return;
			}

			// 2) logged but company not loaded yet -> just go to platform
			if (!roleId) {
				navigate(ROUTES.MAIN);
				return;
			}

			// 3) role based navigation
			if (roleId === 6) {
				navigate(
					type === "cargo" ? ROUTES.CARGO_SEARCH : ROUTES.TRANSPORT_SEARCH,
				);
				return;
			}

			if (roleId === 3) {
				navigate(type === "transport" ? ROUTES.TRANSPORT_SEARCH : ROUTES.MAIN);
				return;
			}

			if (roleId === 4 || roleId === 5) {
				navigate(type === "cargo" ? ROUTES.CARGO_SEARCH : ROUTES.MAIN);
				return;
			}

			// default fallback
			navigate(ROUTES.MAIN);
		},
		[isAuthenticated, onOpenRegister, roleId, navigate],
	);

	return { handleLandingSearchClick };
};
